import { AfterContentChecked, AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: 'app-payment-layout',
  templateUrl: './payment-layout.component.html',
  styleUrls: ['./payment-layout.component.scss']
})
export class PaymentLayoutComponent implements OnInit, AfterViewChecked {
  safeUrl
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<PaymentLayoutComponent>,
    private sanitizer: DomSanitizer
  ) {
    console.log("_data", _data);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this._data.orderData.paymentUrl);
    // this.transform(this._data.orderData.paymentUrl)
    // For a new iframe

    // const iframe = document.createElement("iframe");

    // iframe.onload = function() {
    //   console.log("The iframe is loaded");
    // };
    // iframe.onerror = function() {
    //   console.log("Something wrong happened");
    // };

    // iframe.src = this._data.orderData.paymentUrl;
    // const myiframe = document.getElementById('myiframe');
    // myiframe.appendChild(iframe);


  }


  ngAfterViewChecked(): void {

  }

  ngAfterContentChecked(): void {

  }

  transform() {

  }

  ngOnInit(): void {

  }

  // onError(){
  //   console.log("onError fire");
  // }

  // onLoad(){
  //   console.log("onLoad fire");
  // }

  // errorInSrc(event){
  //   console.log("errorInSrc", event);
  // }

}